export enum ODataExecReturnType {
  // Default
  Array = 0,
  Count = 1,
  PagedResult = 2
}
